import { lazy } from 'react'

export interface RouteItem {
  path: string
  label: string
  icon?: string
  component?: React.LazyExoticComponent<any>
  children?: RouteItem[]
  badgeKey?: string
}

export const routeConfig: RouteItem[] = [
  {
    path: '/dashboard',
    label: '运营大盘',
    icon: 'LayoutDashboard',
    component: lazy(() => import('../pages/dashboard')),
  },
  {
    path: 'stores-group',
    label: '商户管理',
    icon: 'Store',
    children: [
      {
        path: '/stores/audit',
        label: '商户入驻审核',
        component: lazy(() => import('../pages/stores/audit')),
      },
      {
        path: '/stores/list',
        label: '商户档案运维',
        component: lazy(() => import('../pages/stores/list')),
      },
    ],
  },
  {
    path: 'products-group',
    label: '商品中心',
    icon: 'ShoppingBag',
    children: [
      {
        path: '/products/library',
        label: '公共标品库',
        component: lazy(() => import('../pages/products/library')),
      },
      {
        path: '/products/categories',
        label: '商品分类体系',
        component: lazy(() => import('../pages/products/categories')),
      },
      {
        path: '/products/brands',
        label: '平台品牌库',
        component: lazy(() => import('../pages/products/brands')),
      },
      {
        path: '/products/supervision',
        label: '商户商品监管',
        component: lazy(() => import('../pages/products/supervision')),
      },
    ],
  },
  {
    path: 'orders-group',
    label: '订单监督',
    icon: 'ClipboardList',
    children: [
      {
        path: '/orders/supervision',
        label: '全平台订单',
        component: lazy(() => import('../pages/orders/supervision')),
      },
    ],
  },
  {
    path: 'finance-group',
    label: '财务清结算',
    icon: 'Wallet',
    children: [
      {
        path: '/finance',
        label: '资金对账中心',
        component: lazy(() => import('../pages/finance')),
      },
    ],
  },
  {
    path: 'platform-group',
    label: '平台治理',
    icon: 'ShieldCheck',
    children: [
      {
        path: '/platform/users',
        label: '用户与权限',
        component: lazy(() => import('../pages/platform/users')),
      },
      {
        path: '/platform/refund-rules',
        label: '售后维权规则',
        component: lazy(() => import('../pages/platform/refund-rules')),
      },
      {
        path: '/platform/services',
        label: '服务保障说明',
        component: lazy(() => import('../pages/platform/services')),
      },
    ],
  },
  {
    path: 'app-group',
    label: '移动端管理',
    icon: 'Smartphone',
    children: [
      {
        path: '/app/versions',
        label: 'App 版本发布',
        component: lazy(() => import('../pages/app/versions')),
      },
    ],
  },
]

export function getMenuItem(item: RouteItem): any {
  if (item.children) {
    return {
      key: item.path,
      label: item.label,
      icon: item.icon,
      children: item.children.map(getMenuItem),
    }
  }
  return {
    key: item.path,
    label: item.label,
  }
}

export function flattenRoutes(items: RouteItem[]): RouteItem[] {
  const result: RouteItem[] = []
  for (const item of items) {
    if (item.component) result.push(item)
    if (item.children) result.push(...flattenRoutes(item.children))
  }
  return result
}

export default routeConfig
